export default __webpack_public_path__ + "static/media/Thunderskin Bracers.0bd44a22.jpg";